import {
  IconBuildingCommunity,
  IconDashboard,
  IconUserDollar,
  IconUsersGroup,
} from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { useMemo } from 'react';
import {
  GROUP_CLIENTS_ROUTE,
  GROUP_COMPANIES_ROUTE,
  GROUP_MEMBERS_ROUTE,
  GROUP_ROUTE,
} from 'shared/constants';

import type { MenuItem } from '../types';

export function useBuildGroupMenuItems(): ReadonlyArray<MenuItem> {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        path: GROUP_ROUTE,
        label: t(i18nKeys.COMMON.DASHBOARD),
        Icon: IconDashboard,
      },
      {
        path: GROUP_COMPANIES_ROUTE,
        label: t(i18nKeys.GROUP.COMPANIES),
        Icon: IconBuildingCommunity,
      },
      {
        path: GROUP_CLIENTS_ROUTE,
        label: t(i18nKeys.CLIENTS),
        Icon: IconUserDollar,
      },
      {
        path: GROUP_MEMBERS_ROUTE,
        label: t(i18nKeys.GROUP.MEMBERS),
        Icon: IconUsersGroup,
      },
    ],
    [t],
  );
}
